import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@material-ui/core';
import RatingStars from '../../../../components/RatingStars';
import circleLogo from '../../../../assets/img/logo-circulo.png';
import { useStyles } from './styles';

interface Props {
    userName: string;
    userAvatar: string;
    score?: number;
}

const UserScore: FC<Props> = ({ score, userName, userAvatar }) => {
    const classes = useStyles();

    return (
        <Box className={classes.container}>
            <Link to={`/${userName}`} className={classes.avatarContainer}>
                <img className={classes.avatar} src={userAvatar} alt="" />
                <img src={circleLogo} className={classes.icon} alt="" />
            </Link>

            <Link to={`/${userName}`} className={classes.profileLink}>
                <span className={classes.name}>{userName}</span>
                <RatingStars score={score} />
            </Link>
        </Box>
    );
};

export default UserScore;
